import {
  GET_ACCOUNT_STATUS_V2,
  GET_ACCOUNT_STATUS_V2_SUCCESS,
  GET_ACCOUNT_STATUS_V2_FAILED,
  GET_ACC_STS_SUCCESS,
  GET_ACC_STS_FAILED,
  GET_CUSTOMER_PORTFOLIO,
  GET_CUSTOMER_PORTFOLIO_SUCCESS,
  GET_CUSTOMER_PORTFOLIO_FAILED,
  GET_SUBACCOUNT_INVEST,
  GET_SUBACCOUNT_INVEST_SUCCESS,
  GET_SUBACCOUNT_INVEST_FAILED,
  RESET_INVEST_SUBACCOUNT,
  GET_INVEST_ANNOUNCEMENT,
  GET_INVEST_ANNOUNCEMENT_SUCCESS,
  GET_INVEST_ANNOUNCEMENT_FAILED,
  GET_RETIRE_ANNOUNCEMENT,
  GET_RETIRE_ANNOUNCEMENT_SUCCESS,
  GET_RETIRE_ANNOUNCEMENT_FAILED,
  GET_SAVE_ANNOUNCEMENT,
  GET_SAVE_ANNOUNCEMENT_SUCCESS,
  GET_SAVE_ANNOUNCEMENT_FAILED
} from "./constant";

const initialState = {
  customerPortfolio: [],
  loadingCustomerPortfolio: false,
  subAccStsInvestLoading: false,
  subAccStsInvest: {},
  investAnnouncementLoading: false,
  investAnnouncementTitle: "",
  investAnnouncementDescription: "",
  investAnnouncementEndDate: new Date(),
  retireAnnouncementLoading: false,
  retireAnnouncementTitle: "",
  retireAnnouncementDescription: "",
  retireAnnouncementEndDate: new Date(),
  saveAnnouncementLoading: false,
  saveAnnouncementTitle: "",
  saveAnnouncementDescription: "",
  saveAnnouncementEndDate: new Date(),
};

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CUSTOMER_PORTFOLIO:
      return {
        ...state,
        loadingCustomerPortfolio: true
      };
    case GET_CUSTOMER_PORTFOLIO_SUCCESS:
      return {
        ...state,
        customerPortfolio: action.payload,
        loadingCustomerPortfolio: false
      };
    case GET_CUSTOMER_PORTFOLIO_FAILED:
      return {
        ...state,
        loadingCustomerPortfolio: false
      };
    case GET_ACCOUNT_STATUS_V2:
      return {
        ...state,
        accountStatusLoading: true
      };
    case GET_ACCOUNT_STATUS_V2_SUCCESS:
      return {
        ...state,
        accountStatus: action.payload,
        accountStatusLoading: false
      };
    case GET_ACCOUNT_STATUS_V2_FAILED:
      return {
        ...state,
        accountStatusLoading: false
      };
    case GET_ACC_STS_SUCCESS:
      return {
        ...state,
        accStatusRun: action.payload
      };
    case GET_ACC_STS_FAILED:
      return {
        ...state,
        accStatusRun: action.payload
      };
    case GET_SUBACCOUNT_INVEST:
      return {
        ...state,
        subAccStsInvestLoading: true
      };
    case GET_SUBACCOUNT_INVEST_SUCCESS:
      return {
        ...state,
        subAccStsInvest: action.payload,
        subAccStsInvestLoading: false
      };
    case GET_SUBACCOUNT_INVEST_FAILED:
      return {
        ...state,
        subAccStsInvest: {},
        subAccStsInvestLoading: false
      };
    case RESET_INVEST_SUBACCOUNT:
      return {
        ...state,
        subAccStsInvest: {},
        subAccStsInvestLoading: false
      };
    case GET_INVEST_ANNOUNCEMENT:
      return {
        ...state,
        investAnnouncementLoading: true
      }
    case GET_INVEST_ANNOUNCEMENT_SUCCESS:
      const cleaned = action?.payload?.value.replace(/\\/g, "");
      const investAnnouncementDetails = JSON.parse(cleaned || "{}");
      return {
        ...state,
        investAnnouncementTitle: investAnnouncementDetails.title,
        investAnnouncementDescription: investAnnouncementDetails.description,
        investAnnouncementEndDate: investAnnouncementDetails.eT,
        investAnnouncementLoading: false
      }
    case GET_INVEST_ANNOUNCEMENT_FAILED:
      return {
        ...state,
        investAnnouncementTitle: initialState.investAnnouncementTitle,
        investAnnouncementDescription: initialState.investAnnouncementDescription,
        investAnnouncementEndDate: initialState.investAnnouncementEndDate,
        investAnnouncementLoading: false
      }
    case GET_RETIRE_ANNOUNCEMENT:
      return {
        ...state,
        retireAnnouncementLoading: true
      }
    case GET_RETIRE_ANNOUNCEMENT_SUCCESS:
      const cleanedPayload = action?.payload?.value.replace(/\\/g, "");
      const retireAnnouncementDetails = JSON.parse(cleanedPayload || "{}");
      return {
        ...state,
        retireAnnouncementTitle: retireAnnouncementDetails.title,
        retireAnnouncementDescription: retireAnnouncementDetails.description,
        retireAnnouncementEndDate: retireAnnouncementDetails.eT,
        retireAnnouncementLoading: false
      }
    case GET_RETIRE_ANNOUNCEMENT_FAILED:
      return {
        ...state,
        retireAnnouncementTitle: initialState.retireAnnouncementTitle,
        retireAnnouncementDescription: initialState.retireAnnouncementDescription,
        retireAnnouncementEndDate: initialState.retireAnnouncementEndDate,
        retireAnnouncementLoading: false
      }

      case GET_SAVE_ANNOUNCEMENT:
        return {
          ...state,
          saveAnnouncementLoading: true
        }
      case GET_SAVE_ANNOUNCEMENT_SUCCESS:
        const saveAnnouncementDetails = JSON.parse(action?.payload?.value.replace(/\\/g, "") || "{}");
        return {
          ...state,
          saveAnnouncementTitle: saveAnnouncementDetails.title,
          saveAnnouncementDescription: saveAnnouncementDetails.description,
          saveAnnouncementEndDate: saveAnnouncementDetails.eT,
          saveAnnouncementLoading: false
        }
      case GET_SAVE_ANNOUNCEMENT_FAILED:
        return {
          ...state,
          saveAnnouncementTitle: initialState.saveAnnouncementTitle,
          saveAnnouncementDescription: initialState.saveAnnouncementDescription,
          saveAnnouncementEndDate: initialState.saveAnnouncementEndDate,
          saveAnnouncementLoading: false
        }
    default:
      return state;
  }
}
